import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: '',
    about: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    twitter: '',
    youtube: '',
    website: ''
  }
})

export default {
  [types.SET_SPONSOR] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    if (payload.facebook === null) {
      payload.facebook = ''
    }
    if (payload.instagram === null) {
      payload.instagram = ''
    }
    if (payload.linkedin === null) {
      payload.linkedin = ''
    }
    if (payload.twitter === null) {
      payload.twitter = ''
    }
    if (payload.youtube === null) {
      payload.youtube = ''
    }
    if (payload.website === null) {
      payload.website = ''
    }
    state.sponsor = payload
  },
  [types.SET_SPONSORS] (state, payload) {
    state.sponsors = payload.data
    state.pagination = payload.meta.pagination
  }
}
